import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ModalButtons } from '@fcom/ui-components';

import { ItineraryModal } from '../../../modules/ancillaries/interfaces/ancillaries-interface';

@Component({
  selector: 'fin-itinerary-modal',
  templateUrl: './itinerary-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItineraryModalComponent {
  readonly ModalButtons = ModalButtons;

  itineraryModal = input<ItineraryModal>({ open: false, data: null });

  closed = output<boolean>();
}
